import { AREA_ID_PREFIX } from 'app/services/autoLockForms/autoLockForms';
import {
  AutoLockFormsLevelType,
  FinancialInfoSubsectionNames,
  LoanEditorSectionNames,
} from 'app/services/autoLockForms/autoLockForms.constants';

import { FINANCIAL_INFO_VIEWS_PATHS } from '../../FinancialInfo.constants';

const getSubsectionAreaId = subsectionName =>
  `${AREA_ID_PREFIX[AutoLockFormsLevelType.SUBSECTION]}${
    LoanEditorSectionNames.FINANCIAL_INFO
  }-${subsectionName}`;

// Every financial-info table resolves to the appFormsTree subsection area a section-scoped
// checklist item links its `fieldRef` to. Deriving the id here (rather than each table passing
// its own) is what keeps a table from silently losing its "Needed" indicator.
export const AREA_ID_BY_TABLE_NAME = {
  [FINANCIAL_INFO_VIEWS_PATHS.INCOME_AND_EMPLOYMENT]: getSubsectionAreaId(
    FinancialInfoSubsectionNames.EMPLOYMENT_INFO,
  ),
  [FINANCIAL_INFO_VIEWS_PATHS.ASSETS]: getSubsectionAreaId(FinancialInfoSubsectionNames.ASSETS),
  [FINANCIAL_INFO_VIEWS_PATHS.LIABILITIES]: getSubsectionAreaId(
    FinancialInfoSubsectionNames.LIABILITIES,
  ),
  [FINANCIAL_INFO_VIEWS_PATHS.REO]: getSubsectionAreaId(FinancialInfoSubsectionNames.REO),
};
